import { Link } from 'react-router-dom';

export default function Cases() {
  const partners = [
    {
      name: 'Siemens',
      logo: 'https://assets.auxodev.dk/cdn-cgi/image/width=300,quality=90,format=auto/assets/6b13c390-5e11-4ba2-a04f-8e3fde27ab67/siemens.jpg',
      description: 'Global leader in wind power and offshore energy solutions, partnering with Site Facility for remote camp accommodations.',
      link: '/references?client=Siemens'
    },
    {
      name: 'Vestas',
      logo: 'https://assets.auxodev.dk/cdn-cgi/image/width=300,quality=90,format=auto/assets/6b13c390-5e11-4ba2-a04f-8e3fde27ab67/vestas.jpg',
      description: 'The world\'s leading wind turbine manufacturer, collaborating on multiple on-site camps and mobile factory modules.',
      link: '/references?client=Vestas'
    },
    {
      name: 'Wobben Windpower',
      logo: 'https://assets.auxodev.dk/cdn-cgi/image/width=300,quality=90,format=auto/assets/6b13c390-5e11-4ba2-a04f-8e3fde27ab67/wobben.jpg',
      description: 'Pioneering wind energy developer, working with us to establish high-capacity camps in remote international locations.',
      link: '/references?client=Wobben'
    },
    {
      name: 'Mammoet',
      logo: 'https://assets.auxodev.dk/cdn-cgi/image/width=300,quality=90,format=auto/assets/6b13c390-5e11-4ba2-a04f-8e3fde27ab67/mammoet.jpg',
      description: 'Heavy lifting and transport specialists, utilizing our hotel management services across Scandinavia.',
      link: '/references?client=Mammoet'
    },
    {
      name: 'Enercon',
      logo: 'https://assets.auxodev.dk/cdn-cgi/image/width=300,quality=90,format=auto/assets/6b13c390-5e11-4ba2-a04f-8e3fde27ab67/enercon.jpg',
      description: 'Renowned wind energy systems provider, partnering with us for long-term camp setups and residential units.',
      link: '/references?client=Enercon'
    },
    {
      name: 'Total Wind',
      logo: 'https://assets.auxodev.dk/cdn-cgi/image/width=300,quality=90,format=auto/assets/6b13c390-5e11-4ba2-a04f-8e3fde27ab67/total-wind.jpg',
      description: 'Turnkey solutions provider for wind turbine installation, utilizing our full-service camp setups.',
      link: '/references?client=Total'
    }
  ];

  return (
    <div className="pt-[73px]">
      {/* Header Section */}
      <section className="bg-primary text-white py-20 relative overflow-hidden">
        <div className="absolute inset-0 z-0 opacity-10">
          <img
            src="https://assets.auxodev.dk/cdn-cgi/image/width=1600,quality=80,format=auto/assets/6b13c390-5e11-4ba2-a04f-8e3fde27ab67/img-0230.jpg"
            alt="Cases Background"
            className="h-full w-full object-cover"
          />
        </div>
        <div className="relative z-10 mx-auto max-w-7xl px-6 md:px-12 text-center space-y-4">
          <span className="text-accent text-xs font-bold tracking-widest uppercase">Our Collaborations</span>
          <h1 className="text-2xl sm:text-3xl md:text-5xl font-extrabold tracking-tight text-white">
            Trusted by Industry Leaders
          </h1>
          <p className="text-slate-300 max-w-2xl mx-auto leading-relaxed">
            Site Facility has proudly partnered with industry leaders successfully delivering tailored accommodation solutions for their projects.
          </p>
        </div>
      </section>

      {/* Intro Text Section */}
      <section className="py-16 bg-white border-b border-slate-100">
        <div className="mx-auto max-w-4xl px-6 text-center space-y-6">
          <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-primary">Have a look at our cases</h2>
          <p className="text-slate-600 leading-relaxed text-base md:text-lg">
            Site Facility has proudly partnered with industry leaders such as Siemens, Vestas, Wobben Windpower, Mammoet, and Enercon, successfully delivering tailored accommodation solutions for their projects. Explore our trusted collaborations and discover how we have supported these renowned companies in achieving their project goals.
          </p>
        </div>
      </section>

      {/* Partners Grid */}
      <section className="py-20 bg-white">
        <div className="mx-auto max-w-7xl px-6 md:px-12">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {partners.map((partner, idx) => (
              <div 
                key={idx} 
                className="bg-slate-50/50 rounded-2xl border border-slate-100/80 p-8 flex flex-col justify-between hover:bg-slate-50 hover:border-accent/30 hover:shadow-lg hover:-translate-y-1 transition-all duration-300"
              >
                <div className="space-y-6">
                  {/* Logo Container */}
                  <div className="h-24 flex items-center justify-center p-4 bg-slate-50 rounded-xl border border-slate-100/50">
                    <img
                      src={partner.logo}
                      alt={`${partner.name} Logo`}
                      className="max-h-full max-w-full object-contain filter grayscale hover:grayscale-0 transition-all duration-300"
                    />
                  </div>
                  {/* Content */}
                  <div className="space-y-2">
                    <h3 className="text-lg font-bold text-primary">{partner.name}</h3>
                    <p className="text-slate-600 text-sm leading-relaxed">
                      {partner.description}
                    </p>
                  </div>
                </div>

                <div className="pt-6 mt-6 border-t border-slate-50">
                  <Link
                    to="/references"
                    className="inline-flex items-center gap-2 text-xs font-bold text-accent hover:text-accent-light transition-colors duration-200"
                  >
                    <span>View Related Projects</span>
                    <i className="fa-regular fa-arrow-right" />
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-primary text-white text-center relative overflow-hidden">
        <div className="relative z-10 mx-auto max-w-5xl px-6 space-y-6">
          <h2 className="text-xl sm:text-2xl md:text-4xl font-bold tracking-tight text-white">
            Ready to partner with Site Facility?
          </h2>
          <p className="text-slate-300 max-w-2xl mx-auto leading-relaxed">
            Join the ranks of leading global enterprises and let us handle your project accommodations with excellence and efficiency.
          </p>
          <div className="pt-4">
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 py-4 px-8 rounded-xl bg-accent text-white font-semibold hover:bg-accent-light transition-all-300 shadow-md hover:shadow-lg"
            >
              <span>Contact Us Today</span>
              <i className="fa-regular fa-paper-plane text-sm" />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
